import * as React from 'react';
import { Form, Input, Button, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface Props {
    fields: any[];
    onChange: (fields: any[]) => void;
    onRegister: (d: any) => void;
    loading: boolean;
    token?: any;
}

export default function ResetPasswordForm({
                                              fields,
                                              onChange,
                                              onRegister,
                                              loading,
                                              token,
                                          }: Props) {
    const { t } = useTranslation();
    const [form] = Form.useForm();


    function handleSubmit(values: any) {
        if (onRegister) {
            onRegister(values);
        }
    }

    return (
        <Form
            size="large"
            form={form}
            fields={fields}
            onFieldsChange={(changedFields, allFields) => {
                onChange(allFields);
            }}
            onFinish={handleSubmit}
            layout="vertical"
            requiredMark={false}
        >
            <Form.Item
                label={t('resetPassword.email.label')}
                name="email"
                rules={[
                    {
                        required: true, type: 'email',
                        message: t('resetPassword.email.required'),
                    },
                ]}
            >
                <Input type={'email'}/>
            </Form.Item>
            {
                token && <>
                    <div className="__password">
                        <Form.Item
                            label={t('resetPassword.password.label')}
                            name="password"
                            rules={[
                                { required: token, message: t('resetPassword.password.required') },
                            ]}
                        >
                            <Input
                                onChange={() => {
                                    form.validateFields(['password_confirmation']);
                                }}
                                type="password"
                            />
                        </Form.Item>
                    </div>
                    <div className="__password">
                        <Form.Item
                            label={t('resetPassword.password_confirmation.label')}
                            name="password_confirmation"
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!token)
                                            return Promise.resolve();

                                        if (!value) {
                                            return Promise.reject(
                                                t('resetPassword.password.required'),
                                            );
                                        }
                                        if (value && getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            t('resetPassword.password.unmatched'),
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input
                                type="password"
                            />
                        </Form.Item>
                    </div>
                </>
            }
            <br/>
            <Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    shape="round"
                    size={'large'}
                    className="submit"
                >
                    {t('resetPassword.reset')}
                </Button>
            </Form.Item>
        </Form>
    );
}
